module.exports = __webpack_public_path__ + "static/img/Drew-Brees-Consecutive-Completions.0de739b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Drew-Brees-Consecutive-Completions.gif
// module id = 1l0d
// module chunks = 1